export default __webpack_public_path__ + "static/media/close.cc29434e.svg";